/* ===============================
   GLOBALS (same as PDP style)
   =============================== */
let userCity = '';
const resultDiv = document.getElementById('locationResult');

/* ===============================
   LOCATION MAP (same as PDP)
   =============================== */
const locationMap = {
  69840437402: "Santacruz, Mumbai",
  69840830618: "Ahmedabad",
  106251911531: "Delhi",
  69840961690: "Hyderabad",
  69840896154: "Surat",
  105350463851: "Mumbai Online Exclusives, Thane",
  109879034219: "KDH",
  69840863386: "Bangalore",
  69840732314: "Delhi",
  106251845995: "Indore",
  110510670187: "Ludhiana",
  115202654571: "Surat-Men's",
  109719716203: "Mumbai Kala Ghoda",
  110858928491: "Delhi"
};

/* ===============================
   MAIN ZIP CHECK (PLP)
   =============================== */
let isFetchingLocation = false;

function getLocationDetails() {
  const resultDiv = document.querySelector('#locationResult');
  if (resultDiv) {
    resultDiv.classList.remove('hidden')
    resultDiv.textContent = "Valid 6-digit PIN required";
  }
  
  if (isFetchingLocation) return;
  isFetchingLocation = true;

  const input = document.getElementById("pincodeInput");
  const pincode = input?.value?.trim();

  if (!pincode || pincode.length !== 6) {
    isFetchingLocation = false;
    return;
  }
  if (resultDiv) {
    resultDiv.classList.add('hidden')
  }

  /* ✅ SAVE MANUAL PINCODE */
  

  /* ✅ Update selected zip UI */
  const selectedZipText = document.querySelector('.selected-zip span');

  /* ✅ Remove active from saved addresses */
  document.querySelectorAll('.zip-code-input-popup li')
    .forEach(li => li.classList.remove('active'));

  const zipList = window.zipCodeList || [];
  const isPincodeAvailable = zipList.includes(pincode);
  

  fetch(`https://api.postalpincode.in/pincode/${pincode}`)
    .then(res => res.json())
    .then(data => {
      if (data[0]?.Status === "Success") {
        closeZipPopup();
        userCity = data[0].PostOffice[0].District;
        processPLPBadges(userCity);
        localStorage.setItem('plp_selected_address_city', userCity);
        if (selectedZipText) {
          selectedZipText.textContent = pincode;
        }
        localStorage.setItem('plp_selected_pincode', pincode);
      } else if (resultDiv) {
        hideAllPLPBadges();
        resultDiv.classList.remove('hidden');
        resultDiv.textContent = "Valid 6-digit PIN required";
      }
    })
    .catch(() => {
      if (resultDiv) {
        hideAllPLPBadges();
        resultDiv.classList.remove('hidden');
        resultDiv.textContent = "Error fetching location. Please try again.";
      }
    })
    .finally(() => {
      isFetchingLocation = false;
    });
}


/* ===============================
   PROCESS ALL PLP PRODUCTS
   =============================== */
function processPLPBadges(userCity) {
  document.querySelectorAll('.plp-delivery-badge')
    .forEach(badge => processSinglePLPBadge(badge, userCity));
}

/* ===============================
   PROCESS SINGLE PRODUCT BADGE
   =============================== */
function processSinglePLPBadge(badgeEl, userCity) {
  if (!badgeEl || !userCity) return;

  const rawData = badgeEl.dataset.variantInventory;
  if (!rawData) return;

  let parsed;
  try {
    parsed = JSON.parse(rawData.replace(/&quot;/g, '"'));
  } catch {
    return;
  }

  const inventory = parsed?.[0]?.inventory || [];
  const mtoDays = Number(badgeEl.dataset.mtoRtsDays || 0);
  if (!inventory.length) return;

  const locations = inventory.map(loc => ({
    qty: Number(loc.quantity) || 0,
    name: locationMap[loc.location?.id] || ""
  }));

  // console.log('locations',locations)
  const totalStoreQty = locations.reduce((s, l) => s + l.qty, 0);
  // console.log('totalStoreQty',totalStoreQty)
  // console.log('userCity',userCity)
  const isRTSInCity = locations.some(loc =>
    loc.qty > 0 &&
    loc.name.trim() !== "" &&  // <-- skip blank names
    (
      loc.name.toLowerCase().includes(userCity.toLowerCase()) ||
      userCity.toLowerCase().includes(loc.name.toLowerCase())
    )
  );
  // console.log('isRTSInCity',isRTSInCity)
  const sameDay  = badgeEl.querySelector('.same-day');
  const nextDay  = badgeEl.querySelector('.next-day');
  const threeDay = badgeEl.querySelector('.three-day');
  const rtsLabel = badgeEl.closest('.product-card')?.querySelector('.delivery-ready-to-ship');

  [sameDay, nextDay, threeDay].forEach(b => b?.classList.add('hidden'));
  badgeEl.classList.add('hidden');
  rtsLabel?.classList.remove('hidden');

  /* RTS */
  if (isRTSInCity) {
    badgeEl.classList.remove('hidden');
    rtsLabel?.classList.add('hidden');

    if (new Date().getHours() < 15) {
      sameDay?.classList.remove('hidden');
    } else {
      nextDay?.classList.remove('hidden');
    }
    return;
  }

  /* MTO */
  if (!isRTSInCity && mtoDays === 3 && totalStoreQty > 0) {
    console.log('totalStoreQty', totalStoreQty, mtoDays)
    badgeEl.classList.remove('hidden');
    threeDay?.classList.remove('hidden');
    rtsLabel?.classList.add('hidden');
  }
}

function hideAllPLPBadges() {
  document.querySelectorAll('.plp-delivery-badge').forEach(badge => {
    badge.classList.add('hidden');

    badge.querySelectorAll('.badge').forEach(b =>
      b.classList.add('hidden')
    );

    const rtsLabel = badge.closest('.product-card')
      ?.querySelector('.delivery-ready-to-ship');

    rtsLabel?.classList.remove('hidden');
  });
}


/* ===============================
   ZIP POPUP INTERACTIONS (NEW)
   =============================== */
document.addEventListener('DOMContentLoaded', () => {
  console.log('plp delivery budge')
  const wrap = document.querySelector('.zip-code-plp-wrap');
  if (!wrap) return;

  const popup = wrap.querySelector('.zip-code-input-popup');
  const selectedZip = wrap.querySelector('.selected-zip');
  const selectedZipText = selectedZip?.querySelector('span');
  const closeBtn = wrap.querySelector('#close-location');
  const pincodeInput = wrap.querySelector('#pincodeInput');
  const addressItems = wrap.querySelectorAll('li[data-custome-zip]');

  /* open popup */
  selectedZip?.addEventListener('click', () => {
    console.log('click zip')
    popup.classList.add('active');
    document.documentElement.classList.add('location-popup-active');
  });

  // selectedZip?.addEventListener('pointerdown', openPopup, { passive: false });
  // selectedZip?.addEventListener('touchstart', openPopup, { passive: false });
  // selectedZip?.addEventListener('click', openPopup);

  /* close popup */
  closeBtn?.addEventListener('click', () => {
    popup.classList.remove('active');
    document.documentElement.classList.remove('location-popup-active');
  });

  /* saved address click */
  
  const isMobile = window.innerWidth <= 750;
  if (!isMobile) return;

  addressItems.forEach((li, index) => {
    li.dataset.addressKey ||= index; // fallback if not from liquid

    li.addEventListener('click', () => {
      const zip = li.dataset.customeZip;
      const addressKey = li.dataset.addressKey;

      if (!zip) return;

      /* ✅ persist BOTH */
      localStorage.setItem('plp_selected_pincode', zip);
      localStorage.setItem('plp_selected_address_key', addressKey);

      /* UI */
      pincodeInput.value = zip;
      selectedZipText.textContent = zip;

      addressItems.forEach(i => i.classList.remove('active'));
      setTimeout(() => {
        li.classList.add('active');
      }, 10);

      popup.classList.remove('active');
      document.documentElement.classList.remove('location-popup-active');

      getLocationDetails();
    });
  });

  
  const storedPin = localStorage.getItem('plp_selected_pincode');
  const storedAddressKey = localStorage.getItem('plp_selected_address_key');

  if (storedPin) {
    pincodeInput.value = storedPin;
    selectedZipText.textContent = storedPin;

    addressItems.forEach((li, index) => {
      setTimeout(() => {
        li.classList.remove('active')
      }, 10);
      if (!li.dataset.addressKey) {
        li.dataset.addressKey = String(index);
      }

      const zip = li.dataset.customeZip;
      const key = li.dataset.addressKey;

      if (
        storedPin &&
        storedAddressKey &&
        zip === storedPin &&
        key === storedAddressKey
      ) {
        setTimeout(() => {
        li.classList.add('active');
        }, 10);
      }
    });
    getLocationDetails();
  } else {
    if (window.customerDefaultPincode && pincodeInput) {
      pincodeInput.value = window.customerDefaultPincode;
      selectedZipText.textContent = window.customerDefaultPincode;
      getLocationDetails();
    }
  }
});

function closeZipPopup() {
  const popup = document.querySelector('.zip-code-input-popup');
  if (!popup) return;

  popup.classList.remove('active');
  document.documentElement.classList.remove('location-popup-active');
}
